export default __webpack_public_path__ + "static/media/full3.655c4678.jpg";